export default __webpack_public_path__ + "static/media/osito.059e538f.svg";